export default "__VITE_ASSET__8b78ab68__"